export default __webpack_public_path__ + "static/media/wf-isf-sustainability-trends-for-2024_767x577.860a3c58.jpg";